import { DefaultSidebar } from './Default';
import { MarketingPlatformSidebar } from './MarketingPlatform';
import { AovProgressBarSidebar } from './AovProgressBar';
import { BackInStockSidebar } from './BackInStock';
import { ReviewsSidebar } from './Reviews';
import { RecommenderSidebar } from './Recommender';
import { ReperksSidebar } from './Reperks';
import { PromptSidebar } from './Prompt';
import './styles.scss';





const Sidebar = {}
Sidebar.Default = DefaultSidebar;
Sidebar.MarketingPlatform = MarketingPlatformSidebar;
Sidebar.AovProgressBar = AovProgressBarSidebar;
Sidebar.BackInStock = BackInStockSidebar;
Sidebar.Reviews = ReviewsSidebar;
Sidebar.Recommender = RecommenderSidebar;
Sidebar.Reperks = ReperksSidebar;
Sidebar.Prompt = PromptSidebar;
export { Sidebar };

